<script setup lang="ts">
import { computed } from 'vue'
import JwtService from '@/services/jwt'

interface Props {
  bitisMetni: string | undefined
}
const props = defineProps<Props>()

// Bitiş metnindeki {KOD} yer tutucusunu yarışmacının giriş koduyla değiştir.
// Anket (Google Forms vb.) ön-doldurma linki kişiye özel açılsın diye.
// TipTap href'i süslü parantezi %7B..%7D olarak encode edebilir; ikisini de yakala.
const metin = computed(() => {
  const kod = encodeURIComponent(String(JwtService.getTokenObj().gkod ?? ''))
  return (props.bitisMetni ?? '').replace(/%7bkod%7d|\{kod\}/gi, kod)
})
</script>

<template>
  <div
    class="card w-full p-3 md:p-6 space-y-2 flex flex-col items-center justify-center px-4 md:px-6"
  >
    <span class="inline-flex items-center gap-2 rounded-full p-3 bg-gray-50">
      <MIcon name="trophy" size="20px" class="text-gray-800" />
    </span>
    <h2 class="text-title-md text-blue-600">{{ $t('competition_completed.title') }}</h2>
    <p
      class="text-body-md text-gray-700 mt-2 override-font-family"
      v-html="metin || $t('competition_completed.wait_message')"
    ></p>
  </div>
</template>

<style scoped>
@reference "@/assets/main.css";

.override-font-family :deep(a) {
  @apply btn btn-primary my-4 w-full;
}
</style>
